import React, { Component } from "react";
import { connect } from "react-redux";
import { message, Row, Col, Select, Upload, Modal } from "antd";
import axios from "axios";
import moment from "moment";
import { PlusOutlined } from "@ant-design/icons";
import {
  ButtonItem,
  InputNumberItem,
  DatePickerItem,
  ModalItem,
  Form,
  FormItem,
  SelectItem,
  SelectFacturasItem,
  SelectEmpleadosItem,
} from "../../../../Components/Items";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const FOTOS_CONFIG = [
  { field: "fotoOdometro", label: "Odómetro", prefix: "archivoOdometro", urls: "urlsOdometro" },
  { field: "fotoBomba", label: "Bomba", prefix: "archivoBomba", urls: "urlsBomba" },
  { field: "fotoTanque", label: "Tanque", prefix: "archivoTanque", urls: "urlsTanque" },
  { field: "fotoExtra", label: "Extra", prefix: "archivoExtra", urls: "urlsExtra" },
];

class ModalCargaCombustible extends Component {
  formRef = React.createRef();
  state = {
    guardando: false,
    fotoOdometro: [],
    fotoBomba: [],
    fotoTanque: [],
    fotoExtra: [],
    previewVisible: false,
    previewImage: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.inicializar();
    }
  }

  inicializar() {
    const { carga } = this.props;
    if (!carga) {
      // Nueva carga
      this.setState(
        { fotoOdometro: [], fotoBomba: [], fotoTanque: [], fotoExtra: [] },
        () => {
          if (this.formRef.current) {
            this.formRef.current.resetFields();
            this.formRef.current.setFieldsValue({ fecha: moment(), tipoCombustible: "gasolina" });
          }
        }
      );
      return;
    }
    axios
      .post(
        "rendimientos/datosCarga",
        { empresaId: this.props.empresaId, cargaId: carga._id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const d = res.data || {};
        const mapFotos = (arr) => (arr || []).map((e) => this.recuperarArchivo(e)).filter(Boolean);
        this.setState(
          {
            fotoOdometro: mapFotos(d.fotoOdometro),
            fotoBomba: mapFotos(d.fotoBomba),
            fotoTanque: mapFotos(d.fotoTanque),
            fotoExtra: mapFotos(d.fotoExtra),
          },
          () => {
            if (this.formRef.current) {
              this.formRef.current.resetFields();
              this.formRef.current.setFieldsValue({
                fecha: d.fecha ? moment(d.fecha) : moment(),
                kmOdometro: d.kmOdometro,
                litros: d.litros,
                tipoCombustible: d.tipoCombustible || "gasolina",
                precioPorLitro: d.precioPorLitro,
                total: d.total,
                choferId: d.choferId || undefined,
                facturaId: d.facturaId || undefined,
              });
            }
          }
        );
      });
  }

  recuperarArchivo(element) {
    if (element.noFile) return null;
    if (element.base64 && element.base64 !== null) {
      const mimetype =
        element.extension !== "pdf" ? "image/" + element.extension : "application/pdf";
      const byteString = atob(element.base64);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: mimetype });
      const file = new File([blob], element.name, { type: blob.type, lastModified: new Date() });
      const dataUrl = `data:${mimetype};base64,${element.base64}`;
      return {
        uid: `file-${Date.now()}-${element.name}`,
        name: element.name,
        status: "done",
        url: dataUrl,
        thumbUrl: dataUrl,
        originFileObj: file,
        path: element.path,
      };
    }
    if (element.path && (element.path.startsWith("http://") || element.path.startsWith("https://"))) {
      return {
        uid: `url-${Date.now()}`,
        name: element.name,
        status: "done",
        url: element.path,
        path: element.path,
        extension: element.extension,
      };
    }
    return null;
  }

  onValuesChange(changed) {
    const f = this.formRef.current;
    const litros = f.getFieldValue("litros") || 0;
    if ("total" in changed) {
      
      const total = f.getFieldValue("total") || 0;
      if (litros > 0) {
        f.setFieldsValue({ precioPorLitro: +(total / litros).toFixed(4) });
      }
    } else if ("litros" in changed || "precioPorLitro" in changed) {
      // Cambió litros o precio -> recalcular el total
      const precio = f.getFieldValue("precioPorLitro") || 0;
      f.setFieldsValue({ total: +(litros * precio).toFixed(2) });
    }
  }

  onFinish(values) {
    const { carga, vehiculoId } = this.props;
    this.setState({ guardando: true });

    const fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    fd.append("proyectoId", vehiculoId);
    if (carga) fd.append("cargaId", carga._id);
    fd.append("fecha", values.fecha ? values.fecha.toISOString() : "");
    fd.append("kmOdometro", values.kmOdometro != null ? values.kmOdometro : "");
    fd.append("litros", values.litros != null ? values.litros : "");
    fd.append("tipoCombustible", values.tipoCombustible || "gasolina");
    fd.append("precioPorLitro", values.precioPorLitro != null ? values.precioPorLitro : "");
    fd.append("total", values.total != null ? values.total : "");
    fd.append("choferId", values.choferId || "null");
    fd.append("facturaId", values.facturaId || "null");

    const esUrlExterna = (f) =>
      typeof f.url === "string" && (f.url.startsWith("http://") || f.url.startsWith("https://"));

    FOTOS_CONFIG.forEach(({ field, prefix, urls }) => {
      const arr = this.state[field] || [];
      arr.forEach((element, index) => {
        const nombre = element.path ? `${prefix}:${element.path}` : `${prefix}${index + 1}`;
        fd.append(nombre, element.originFileObj || element);
      });
      const urlsExternas = arr.filter(esUrlExterna).map((f) => f.url);
      fd.append(urls, JSON.stringify(urlsExternas));
    });

    const endpoint = carga
      ? "rendimientos/editarCargaCombustible"
      : "rendimientos/agregarCargaCombustible";

    axios
      .post(endpoint, fd, { headers: { ...this.props.headersToken } })
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data && res.data.success === 2) {
          message.success(carga ? "Carga actualizada" : "Carga registrada");
          if (this.formRef.current) this.formRef.current.resetFields();
          this.props.onClose(true);
        } else if (res.data && res.data.success === 1) {
          message.error(res.data.message || "No se pudo guardar la carga");
        } else {
          message.error("Hubo un error y la carga no se guardó");
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        message.error("Hubo un error y la carga no se guardó");
      });
  }

  async customRequestFoto(field, e) {
    const file = e.file;
    const isImage = ["image/jpeg", "image/png", "image/webp"].includes(file.type);
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isImage) {
      message.error(`${file.name} no es un tipo de imagen válido`);
      e.onError("Tipo de archivo inválido");
      return;
    }
    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError("Archivo demasiado grande");
      return;
    }
    if (file.type === "image/webp") {
      message.warning("Las imágenes webp no se incluyen en el PDF. Usa JPG o PNG si vas a imprimir/enviar.");
    }
    const preview = await getBase64(file);
    const fileObj = {
      uid: file.uid || `${Date.now()}`,
      name: file.name,
      status: "done",
      preview,
      thumbUrl: preview,
      url: preview,
      originFileObj: file,
    };
    this.setState({ [field]: [fileObj] });
    e.onSuccess("ok");
  }

  onRemoveFoto(field, file) {
    this.setState({ [field]: (this.state[field] || []).filter((f) => f !== file) });
  }

  handlePreviewFoto(file) {
    const src = file.url || file.preview || file.thumbUrl;
    this.setState({ previewVisible: true, previewImage: src });
  }

  cerrar() {
    if (this.formRef.current) this.formRef.current.resetFields();
    this.props.onClose(false);
  }

  renderUploadFoto(field, label) {
    return (
      <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: 12, fontWeight: 500, marginBottom: 4 }}>{label}</p>
        <Upload
          listType="picture-card"
          fileList={this.state[field]}
          accept="image/*"
          maxCount={1}
          customRequest={(e) => this.customRequestFoto(field, e)}
          onRemove={(e) => this.onRemoveFoto(field, e)}
          onPreview={(f) => this.handlePreviewFoto(f)}
        >
          {(this.state[field] || []).length >= 1 ? null : (
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 4, fontSize: 11 }}>Subir</div>
            </div>
          )}
        </Upload>
      </div>
    );
  }

  render() {
    const { carga } = this.props;
    return (
      <>
        <ModalItem
          title={carga ? "Editar carga de combustible" : "Registrar carga de combustible"}
          visible={this.props.visible}
          spinning={this.state.guardando}
          onCancel={this.cerrar.bind(this)}
          forceRender
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="cargaCombustible"
            layoutForm="vertical"
            onValuesChange={this.onValuesChange.bind(this)}
            onFinish={this.onFinish.bind(this)}
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                loading={this.state.guardando}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                {carga ? "Guardar cambios" : "Registrar carga"}
              </ButtonItem>
            }
          >
            <Row gutter={12}>
              <Col xs={24} sm={12}>
                <FormItem name="fecha" label="Fecha" required initialValue={moment()}>
                  <DatePickerItem placeholder="Fecha de la carga" allowClear={false} style={{ width: "100%" }} />
                </FormItem>
              </Col>
              <Col xs={24} sm={12}>
                <FormItem name="tipoCombustible" label="Tipo de combustible" required initialValue="gasolina">
                  <SelectItem placeholder="Selecciona">
                    <Select.Option value="gasolina">Gasolina</Select.Option>
                    <Select.Option value="diesel">Diesel</Select.Option>
                  </SelectItem>
                </FormItem>
              </Col>
              <Col xs={24} sm={12}>
                <FormItem name="kmOdometro" label="KM del odómetro" required numberCero>
                  <InputNumberItem placeholder="Ej. 1000" min={0} sinWidth style={{ width: "100%" }} />
                </FormItem>
              </Col>
              <Col xs={24} sm={12}>
                <FormItem name="litros" label="Litros" required numberCero>
                  <InputNumberItem placeholder="Ej. 25" min={0} sinWidth style={{ width: "100%" }} />
                </FormItem>
              </Col>
              <Col xs={24} sm={12}>
                <FormItem name="precioPorLitro" label="Precio por litro" numberCero>
                  <InputNumberItem dinero placeholder="Precio / L" min={0} sinWidth style={{ width: "100%" }} />
                </FormItem>
              </Col>
              <Col xs={24} sm={12}>
                <FormItem
                  name="total"
                  label="Total"
                  numberCero
                  tooltip="Se calcula automáticamente (litros × precio por litro), pero puedes editarlo manualmente."
                >
                  <InputNumberItem dinero placeholder="Total" min={0} sinWidth style={{ width: "100%" }} />
                </FormItem>
              </Col>
              <Col xs={24} sm={12}>
                <FormItem name="choferId" label="Chofer" required>
                  <SelectEmpleadosItem
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    placeholder="Buscar chofer"
                    width="100%"
                    dropdownMatchSelectWidth={450}
                  />
                </FormItem>
              </Col>
              <Col xs={24} sm={12}>
                <FormItem name="facturaId" label="Factura (opcional)">
                  <SelectFacturasItem
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    placeholder="Buscar factura por código o proveedor"
                    width="100%"
                    dropdownMatchSelectWidth={500}
                  />
                </FormItem>
              </Col>
            </Row>

            <p style={{ fontWeight: 600, fontSize: 13, margin: "6px 0 8px" }}>Evidencia fotográfica (opcional)</p>
            <Row gutter={12}>
              {FOTOS_CONFIG.map(({ field, label }) => (
                <Col xs={12} sm={6} key={field}>
                  {this.renderUploadFoto(field, label)}
                </Col>
              ))}
            </Row>
          </Form>
        </ModalItem>

        <Modal
          visible={this.state.previewVisible}
          footer={null}
          onCancel={() => this.setState({ previewVisible: false })}
        >
          <img alt="preview" style={{ width: "100%" }} src={this.state.previewImage} />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalCargaCombustible);
